<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">群組列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-6 text-left">
                  <div class="form-group text-left" v-if="!history">
                    <router-link :to="{path: '/crGroup/' + $route.params.brand_id}">
                      <div class="btn btn-default btn-table-title">新增群組</div>
                    </router-link>
                  </div>
                </div>
                <div class="col-sm-6 text-right">
                  <div class="form-group">
                    <select class="form-control h-38">
                      <option value="1">名稱</option>
                      <option value="2">代碼</option>
                    </select>
                  </div>
                  <div class="form-group search-bar">
                    <div class="input-group">
                      <input class="form-control" type="text">
                      <span class="input-group-addon c-pointer"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <thead>
                      <tr role="row">
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱 (ID)</th>
                        <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">店家 (ID)</th>-->
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">建立時間</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">更新時間</th>
                        <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="!history">總訂單數</th>-->
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="even" role="row" v-for="(group, index) in groupList">
                        <td class="sorting_1">
                          {{index + 1}}
                        </td>
                        <td>{{group.name}} ({{group.id}})</td>
                        <!--
                        <td>
                          <span v-for="store in group.stores">
                            <span class="label label-primary">{{store.store_name}} ({{store.store_id}})</span>
                            <br>
                          </span>
                        </td>
                        -->
                        <td>{{group.create_time}}</td>
                        <td>{{group.edit_time}}</td>
                        <td>
                          <router-link :to="{path: '/upGroup/' + $route.params.brand_id +'/' + group.id}">
                            <button class="btn btn-default"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                          :groupAmount="groupAmount" :clickPage="clickPage"
                ></paginate>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'

export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      history: false,
      groupList: [],
      current: {
        openList: {},
        deliveryList: {},
        payList: {},
        name: ''
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getStateName (state) {
      if (state === 0) {
        return '尚未營業'
      } else if (state === 1) {
        return '籌備中'
      } else if (state === 2) {
        return '營業中'
      } else if (state === 3) {
        return '休息中'
      } else if (state === 9) {
        return '已歇業'
      }
    },
    getDayName (day) {
      if (day === 1) {
        return '日'
      } else if (day === 2) {
        return '一'
      } else if (day === 3) {
        return '二'
      } else if (day === 4) {
        return '三'
      } else if (day === 5) {
        return '四'
      } else if (day === 6) {
        return '五'
      } else if (day === 7) {
        return '六'
      }
    },
    getStoreGroupList () {
      var self = this
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroupList?page=' + data.page + '&size=' + data.size
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.groupList = response.data.list
          self.total = response.data.list_total
        }
      })
    },
    openModal (store) {
      this.current.openList = store.opening_info
      this.current.deliveryList = store.delivery_info
      this.current.payList = store.trade_info
      this.current.name = store.name_short
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getStoreGroupList()
    }
  },
  created () {
    const path = this.$route.name
    if (path === 'storeHistoryTable') this.history = true
    this.getStoreGroupList()
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupTable.vue?37fd6c88